import { arrayBufferToHexString } from './EncryptionHelper';

const getCryptoApi = (): SubtleCrypto => window.crypto.subtle;

export const subtleCryptoAvailable = (): boolean => {
	return window.crypto && window.crypto.subtle ? true : false;
};

export async function digestString(
	input: string,
	algorithm: AlgorithmIdentifier
): Promise<string> {
	const api = getCryptoApi();
	const encoder = new TextEncoder();
	const dataToDigest = encoder.encode(input);
	const dataBuffer = await api.digest(algorithm, dataToDigest);
	return arrayBufferToHexString(dataBuffer);
}

export async function getSHA512Digest(input: string): Promise<string> {
	return await digestString(input, 'SHA-512');
}

export async function getSHA1Digest(input: string): Promise<string> {
	return await digestString(input, 'SHA-1');
}
